import { setCookie } from 'utilities/browser';
import { baseAPIRequest } from 'utilities/http';
import { utagLinkSort } from 'features/tealium/';

const pageNumRegex = /page_\d+\//;
const trackSortEvent = utagLinkSort();

const initAvailableInStore = () => {

	const checkbox = document.getElementById('availableInStoreCheckbox');

	if (!checkbox) {

		return;

	}

	checkbox.addEventListener('change', async (e) => {

		try {

			e.target.setAttribute('disabled', true);

			const isChecked = e.target.checked;
			const url = '/api/connectascustomer/usersessionmanager/currentusersession/configurations/';

			const data = {
				Keyname: 'InStoreOptionChecked',
				Value: isChecked
			};
			const utagData = window.utag_data;
			trackSortEvent({
				eventAction: `${isChecked ? 'Check' : 'Uncheck'}-Available At This Location`,
				eventLabel: `${utagData.store_name} ${utagData.store_number}`
			});

			await baseAPIRequest({ url, data, params: { method: 'POST' } });

			window.location.href = window.location.href.replace(pageNumRegex, '');

		} catch (err) {

			e.target.removeAttribute('disabled');

		}

	});

};

export default initAvailableInStore;
